import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Form from '@components/library/form/Form';
import InputContainer from '@components/library/input_container/InputContainer';
import renderModal from '@components/show_page/modals/renderModal';
import { create as submitRequest } from '@api/v4/resources/download_requests';
import { pluralizeObject } from '@helpers/show_page_helpers';

const RequestDownloadAccessModal = ({
  closeModal,
  selectedAssetKeys,
}) => {
  const [formDisabled, setFormDisabled] = useState(false);

  useEffect(() => (() => closeModal()), []);

  const assetQtyObject = pluralizeObject(selectedAssetKeys);
  let resourceInfo;

  if (BFG.manifest) {
    resourceInfo = `the "${BFG.manifest.name}" Share Link`;
  } else if (BFG.resource.type === 'collection') {
    resourceInfo = `the "${BFG.resource.name}" Collection`;
  }

  const successOptions = () => ({
    type: 'success',
    title: t('Success!'),
    text: t(`You have requested access to download ${assetQtyObject.qty} asset${assetQtyObject.plural} from ${resourceInfo}`),
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: t('Close'),
    allowOutsideClick: true,
    customClass: 'swal-request-download-confirmation',
  });

  const handleSubmit = (inputs) => {
    setFormDisabled(true);
    let key;
    let type;

    if (BFG.manifest) {
      ({ key, type } = BFG.manifest);
    } else if (BFG.resource && BFG.resource.type === 'collection') {
      ({ key, type } = BFG.resource);
    }

    const inputValues = {};
    Object.keys(inputs).forEach((input) => { inputValues[input] = inputs[input].value; });

    submitRequest({
      key,
      type,
      assetKeys: [...selectedAssetKeys],
      ...inputValues
    })
      .then(() => {
        window.swal(successOptions());
      })
      .catch((err) => {
        setFormDisabled(false);
        console.log(err);
      });
  };

  return (
    <div className="modal-content-wrapper request-download-modal">
      <div className="modal-content-wrapper__header">
        <span className="bff-request-download icon" aria-hidden="true" />
        <h3 className="modal-title">{t('Request Access')}</h3>
        <button
          className="close-button"
          onClick={closeModal}
          type="button"
        >
          <span className="bff-close" />
        </button>
      </div>
      <div className="modal-content-wrapper__body">
        <div>
          <h3 className="body-title">
            {t('Provide your contact information and intended usage for the selected assets.')}
          </h3>
          <Form
            disabledByParent={formDisabled}
            onSubmit={handleSubmit}
          >
            <InputContainer
              attributes={{
                name: 'name',
                type: 'text',
              }}
              labelCopy={t('Name')}
            />
            <InputContainer
              attributes={{
                name: 'email-address',
                type: 'email',
              }}
              labelCopy={t('Email Address')}
            />
            <InputContainer
              attributes={{
                name: 'company',
                type: 'text',
              }}
              labelCopy={t('Company')}
            />
            <InputContainer
              attributes={{
                name: 'usage-details',
                type: 'textarea',
              }}
              labelCopy={t('Usage Details')}
            />
          </Form>
        </div>
      </div>
    </div>
  );
};

RequestDownloadAccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

const ModalComponent = renderModal(RequestDownloadAccessModal, 'request-download-access-modal');
export default ModalComponent;
